export default {
  'app.settings.menuMap.basic': 'Основные настройки',
  'app.settings.menuMap.security': 'Настройки безопасности',
  'app.settings.menuMap.binding': 'Привязка аккаунтов',
  'app.settings.menuMap.notification': 'Уведомления о новых сообщениях',
  'app.settings.basic.avatar': 'Аватар',
  'app.settings.basic.change-avatar': 'Изменить аватар',
  'app.settings.basic.email': 'Email',
  'app.settings.basic.email-message': 'Пожалуйста, введите ваш email!',
  'app.settings.basic.nickname': 'Никнейм',
  'app.settings.basic.nickname-message': 'Пожалуйста, введите ваш никнейм!',
  'app.settings.basic.profile': 'Личный профиль',
  'app.settings.basic.profile-message': 'Пожалуйста, заполните личный профиль!',
  'app.settings.basic.profile-placeholder': 'Краткая информация о себе',
  'app.settings.basic.country': 'Страна/Регион',
  'app.settings.basic.country-message': 'Пожалуйста, укажите вашу страну!',
  'app.settings.basic.geographic': 'Область или город',
  'app.settings.basic.geographic-message':
    'Пожалуйста, укажите ваше местоположение!',
  'app.settings.basic.address': 'Адрес улицы',
  'app.settings.basic.address-message': 'Пожалуйста, введите ваш адрес!',
  'app.settings.basic.phone': 'Номер телефона',
  'app.settings.basic.phone-message': 'Пожалуйста, введите ваш телефон!',
  'app.settings.basic.update': 'Обновить информацию',
  'app.settings.security.strong': 'Сильный',
  'app.settings.security.medium': 'Средний',
  'app.settings.security.weak': 'Слабый',
  'app.settings.security.password': 'Пароль аккаунта',
  'app.settings.security.password-description': 'Текущая надежность пароля',
  'app.settings.security.phone': 'Телефон для восстановления',
  'app.settings.security.phone-description': 'Привязанный телефон',
  'app.settings.security.question': 'Контрольный вопрос',
  'app.settings.security.question-description':
    'Контрольный вопрос не установлен, политика безопасности эффективно защищает аккаунт',
  'app.settings.security.email': 'Резервный email',
  'app.settings.security.email-description': 'Привязанный email',
  'app.settings.security.mfa': 'Устройство MFA',
  'app.settings.security.mfa-description':
    'Устройство MFA не привязано, после привязки потребуется двойное подтверждение',
  'app.settings.security.modify': 'Изменить',
  'app.settings.security.set': 'Установить',
  'app.settings.security.bind': 'Привязать',
  'app.settings.binding.taobao': 'Привязка Taobao',
  'app.settings.binding.taobao-description': 'Аккаунт Taobao не привязан',
  'app.settings.binding.alipay': 'Привязка Alipay',
  'app.settings.binding.alipay-description': 'Аккаунт Alipay не привязан',
  'app.settings.binding.dingding': 'Привязка DingTalk',
  'app.settings.binding.dingding-description': 'Аккаунт DingTalk не привязан',
  'app.settings.binding.bind': 'Привязать',
  'app.settings.notification.password': 'Пароль аккаунта',
  'app.settings.notification.password-description':
    'Сообщения от других пользователей будут отправляться в виде внутренних уведомлений',
  'app.settings.notification.messages': 'Системные сообщения',
  'app.settings.notification.messages-description':
    'Системные сообщения будут отправляться в виде внутренних уведомлений',
  'app.settings.notification.todo': 'Уведомления о задачах',
  'app.settings.notification.todo-description':
    'Список задач будет отправляться в виде внутренних уведомлений',
  'app.settings.open': 'Включить',
  'app.settings.close': 'Отключить',
};
